import React, { FC } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import SelectVesselPage from './SelectVesselFeature';

const VesselsFeature: FC = () => {
  const location = useLocation<{ returnUrl?: string }>();
  const history = useHistory();
  const handleSelectVessel = () => {
    // TODO: Add event capture

    if (location?.state?.returnUrl) {
      history.push(location.state.returnUrl);
      return;
    }

    history.goBack();
  };

  return (
    <Switch>
      <Route path="/maps/vessels/select-vessel" exact>
        <SelectVesselPage
          onBack={history.goBack}
          onSelectVessel={handleSelectVessel}
        />
      </Route>
    </Switch>
  );
};

export default VesselsFeature;
